<template>
  <pt-customer-manage class="pt-customer-manage__page"></pt-customer-manage>
</template>

<script>
import PtCustomerManage from 'cps/customer-manage/pt-customer-manage/withData'
export default {
  name: 'pt-customer-manage__view',
  components: {
    'pt-customer-manage': PtCustomerManage
  }
}
</script>
